module.exports = __webpack_public_path__ + "img/logo.d31731fc.png";